import eCommerceComponent from './index.vue';
import eCommerceDetail from './detail/index.vue';
export default [
  {
    path: 'list',
    component: eCommerceComponent
  },
  {
    path: 'detail',
    component: eCommerceDetail,
    meta: {
      title: '详情',
      breadCrumbShowIndexArr: [1, 2]
    }
  }
];
